<div class="container m-0 p-0">
  <div class="row">
    <div class="col dialog-title">
      {{ data.table | camelCase }}
    </div>
  </div>
  <div class="row">
    <div class="col dialog-content">
      <div
        *ngFor="let item of data.content | objectKey; let i = index"
        [formGroup]="editModalGroup"
      >
        <ng-container
          [ngSwitch]="data.headers[i].type"
          *ngIf="!data.headers[i].notVisible"
        >
          <ng-container *ngSwitchCase="typeOfData.datePicker">
            <div class="modal__item row">
              <label
                class="label-input col-4"
                appMarkAsterisk
                [formGroup]="editModalGroup"
                [controlName]="data.headers[i].key"
                [touched]="editModalGroup.get(data.headers[i].key)!.touched"
                >{{ data.headers[i].key | camelCase }}</label
              >
              <app-datepicker
                class="col-2"
                [formControlName]="data.headers[i].key"
                [isDisabled]="!data.headers[i].isEditable"
                [deadLine]="
                  data.headers[i].key === addictedControlName ? deadLine : ''
                "
                [staticPropery]="true"
                (datepickerOpened)="isDatePickerOpened = $event"
              ></app-datepicker>
              <app-error-field
                [displayError]="
                  isFieldInvalid(data.headers[i].key, editModalGroup) &&
                  editModalGroup.get(data.headers[i].key)!.hasError('required')
                "
                [errorMessage]="'The field is required'"
              ></app-error-field>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="typeOfData.dropDown">
            <ng-container [ngSwitch]="data.headers[i].key">
              <ng-container *ngSwitchCase="'role'">
                <div class="modal__item row">
                  <label
                    class="label-input col-4"
                    appMarkAsterisk
                    [formGroup]="editModalGroup"
                    [controlName]="data.headers[i].key"
                    [touched]="editModalGroup.get(data.headers[i].key)!.touched"
                    >{{ data.headers[i].key | camelCase }}</label
                  >
                  <div
                    class="dropdown__wrapper"
                    [class.no-index]="isDatePickerOpened"
                  >
                    <app-dropdown
                      class="col-2"
                      [formControlName]="data.headers[i].key"
                      [items]="data.dropdown.TrainingRole"
                    ></app-dropdown>
                    <app-error-field
                      [displayError]="
                        isFieldInvalid(data.headers[i].key, editModalGroup) &&
                        editModalGroup
                          .get(data.headers[i].key)!
                          .hasError('required')
                      "
                      [errorMessage]="'The field is required'"
                    ></app-error-field>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'englishLevelSpeaking'">
                <div class="modal__item row">
                  <label
                    class="label-input col-4"
                    appMarkAsterisk
                    [formGroup]="editModalGroup"
                    [controlName]="data.headers[i].key"
                    [touched]="editModalGroup.get(data.headers[i].key)!.touched"
                    >{{ data.headers[i].key | camelCase }}</label
                  >
                  <div
                    class="dropdown__wrapper"
                    [class.no-index]="isDatePickerOpened"
                  >
                    <app-dropdown
                      class="col-2"
                      [formControlName]="data.headers[i].key"
                      [items]="data.dropdown.EnglishLevel"
                    ></app-dropdown>
                    <app-error-field
                      [displayError]="
                        isFieldInvalid(data.headers[i].key, editModalGroup) &&
                        editModalGroup
                          .get(data.headers[i].key)!
                          .hasError('required')
                      "
                      [errorMessage]="'The field is required'"
                    ></app-error-field>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'englishLevelGrammar'">
                <div class="modal__item row">
                  <label
                    class="label-input col-4"
                    appMarkAsterisk
                    [formGroup]="editModalGroup"
                    [controlName]="data.headers[i].key"
                    [touched]="editModalGroup.get(data.headers[i].key)!.touched"
                    >{{ data.headers[i].key | camelCase }}</label
                  >
                  <div
                    class="dropdown__wrapper"
                    [class.no-index]="isDatePickerOpened"
                  >
                    <app-dropdown
                      class="col-2"
                      [formControlName]="data.headers[i].key"
                      [items]="data.dropdown.EnglishLevel"
                    ></app-dropdown>
                    <app-error-field
                      [displayError]="
                        isFieldInvalid(data.headers[i].key, editModalGroup) &&
                        editModalGroup
                          .get(data.headers[i].key)!
                          .hasError('required')
                      "
                      [errorMessage]="'The field is required'"
                    ></app-error-field>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'mentor'">
                <div class="modal__item row">
                  <label
                    class="label-input col-4"
                    appMarkAsterisk
                    [formGroup]="editModalGroup"
                    [controlName]="data.headers[i].key"
                    [touched]="editModalGroup.get(data.headers[i].key)!.touched"
                    >{{ data.headers[i].key | camelCase }}</label
                  >
                  <div
                    class="dropdown__wrapper"
                    [class.no-index]="isDatePickerOpened"
                  >
                    <app-dropdown
                      class="col-2"
                      [formControlName]="data.headers[i].key"
                      [items]="data.dropdown.Mentors"
                    ></app-dropdown>
                    <app-error-field
                      [displayError]="
                        isFieldInvalid(data.headers[i].key, editModalGroup) &&
                        editModalGroup
                          .get(data.headers[i].key)!
                          .hasError('required')
                      "
                      [errorMessage]="'The field is required'"
                    ></app-error-field>
                  </div>
                </div>
              </ng-container>
              <ng-container
                *ngIf="data.table !== ProfessionalTableType.TechInterview"
              >
                <ng-container *ngSwitchCase="'status'">
                  <div class="modal__item row">
                    <label
                      class="label-input col-4"
                      appMarkAsterisk
                      [formGroup]="editModalGroup"
                      [controlName]="data.headers[i].key"
                      [touched]="
                        editModalGroup.get(data.headers[i].key)!.touched
                      "
                      >{{ data.headers[i].key | camelCase }}</label
                    >
                    <div
                      class="dropdown__wrapper"
                      [class.no-index]="isDatePickerOpened"
                    >
                      <app-dropdown
                        class="col-2"
                        [disabl]="!data.headers[i].isEditable"
                        [formControlName]="data.headers[i].key"
                        [items]="data.dropdown.EventStatus"
                      >
                      </app-dropdown>
                      <app-error-field
                        [displayError]="
                          isFieldInvalid(data.headers[i].key, editModalGroup) &&
                          editModalGroup
                            .get(data.headers[i].key)!
                            .hasError('required')
                        "
                        [errorMessage]="'The field is required'"
                      ></app-error-field>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
              <ng-container
                *ngIf="data.table === ProfessionalTableType.EnglishCourses"
              >
                <ng-container *ngSwitchCase="'name'">
                  <div class="modal__item row">
                    <label
                      class="label-input col-4"
                      appMarkAsterisk
                      [formGroup]="editModalGroup"
                      [controlName]="data.headers[i].key"
                      [touched]="
                        editModalGroup.get(data.headers[i].key)!.touched
                      "
                      >{{ data.headers[i].key | camelCase }}</label
                    >
                    <div
                      class="dropdown__wrapper"
                      [class.no-index]="isDatePickerOpened"
                    >
                      <app-dropdown
                        class="col-2"
                        [disabl]="!!data.headers[i].isEditable"
                        [formControlName]="data.headers[i].key"
                        [items]="data.dropdown.EnglishCourses"
                      >
                      </app-dropdown>
                      <app-error-field
                        [displayError]="
                          isFieldInvalid(data.headers[i].key, editModalGroup) &&
                          editModalGroup
                            .get(data.headers[i].key)!
                            .hasError('required')
                        "
                        [errorMessage]="'The field is required'"
                      ></app-error-field>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
              <ng-container *ngSwitchDefault>
                <div class="modal__item row">
                  <label
                    class="label-input col-4"
                    appMarkAsterisk
                    [formGroup]="editModalGroup"
                    [controlName]="data.headers[i].key"
                    [touched]="editModalGroup.get(data.headers[i].key)!.touched"
                    >{{ data.headers[i].key | camelCase }}</label
                  >
                  <div
                    class="dropdown__wrapper"
                    [class.no-index]="isDatePickerOpened"
                  >
                    <app-dropdown
                      class="col-2"
                      [formControlName]="data.headers[i].key"
                      [items]="
                        data.headers[i].isMultiDropdown
                          ? data.dropdown.Interviewers
                          : defaultDropdown
                      "
                      [isMultiselect]="!!data.headers[i].isMultiDropdown"
                    ></app-dropdown>
                    <app-error-field
                      [displayError]="
                        isFieldInvalid(data.headers[i].key, editModalGroup) &&
                        editModalGroup
                          .get(data.headers[i].key)!
                          .hasError('required')
                      "
                      [errorMessage]="'The field is required'"
                    ></app-error-field>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>

          <ng-container *ngSwitchCase="typeOfData.link">
            <div
              class="icon__attach_document"
              *ngIf="editModalGroup.controls['file']"
            >
              <img
                class="icon"
                *ngIf="!editModalGroup.controls['file']?.value"
                src="assets/icons/svg/attach_document/none.svg"
                alt="icon"
                (click)="attachLink()"
              />
              <a [href]="editModalGroup.controls['file'].value" target="_blank">
                <img
                  *ngIf="editModalGroup.controls['file']?.value"
                  class="interview__attached_doc icon"
                  src="assets/icons/svg/attached_document/normal.svg"
                  alt="icon"
                />
              </a>
              <i
                *ngIf="editModalGroup.controls['file']?.value"
                class="icon-close icon blue"
                (click)="deleteDocLink()"
              ></i>
            </div>
          </ng-container>

          <ng-container *ngSwitchDefault>
            <div class="modal__item row" *ngIf="data.headers[i].key !== 'file'">
              <label
                class="label-input col-4"
                appMarkAsterisk
                [formGroup]="editModalGroup"
                [controlName]="data.headers[i].key"
                [touched]="editModalGroup.get(data.headers[i].key)!.touched"
                >{{ data.headers[i].key | camelCase }}</label
              >
              <div class="input__wrapper col-2">
                <input
                  type="text"
                  class="input__basic"
                  placeholder=" "
                  [formControlName]="data.headers[i].key"
                />
                <app-error-field
                  [displayError]="
                    isFieldInvalid(data.headers[i].key, editModalGroup) &&
                    editModalGroup
                      .get(data.headers[i].key)!
                      .hasError('required')
                  "
                  [errorMessage]="'The field is required'"
                ></app-error-field>
                <app-error-field
                  [displayError]="
                    editModalGroup
                      .get(data.headers[i].key)!
                      .hasError('maxlength')
                  "
                  [errorMessage]="'Field length is too long'"
                ></app-error-field>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="dialog-buttons" [class.justify-content-end]="!isAbleToDelete">
    <img
      class="trash"
      src="assets/icons/svg/trash/ion_trash-bin.svg"
      alt="trash"
      *ngIf="isAbleToDelete"
      (click)="deleteRow()"
    />
    <div class="col-auto p-0 mb-3">
      <button class="button button__save add-margin" (click)="saveChanges()">
        Save
      </button>
      <button class="button button__cancel" (click)="changes()">Cancel</button>
    </div>
  </div>
</div>
